import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'delimiterDisplay'
})
export class DelimiterDisplayPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    var result:string='';
    if(value=='\t') result='tab'
    else result=value;
    return result;
  }
}